"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return XcMigrationSourcev2;
    }
});
const _nc_011 = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_011"));
const _nc_012_alter_column_data_types = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_012_alter_column_data_types"));
const _nc_013_sync_source = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_013_sync_source"));
const _nc_014_alter_column_data_types = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_014_alter_column_data_types"));
const _nc_015_add_meta_col_in_column_table = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_015_add_meta_col_in_column_table"));
const _nc_016_alter_hooklog_payload_types = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_016_alter_hooklog_payload_types"));
const _nc_017_add_user_token_version_column = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_017_add_user_token_version_column"));
const _nc_018_add_meta_in_view = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_018_add_meta_in_view"));
const _nc_019_add_meta_in_meta_tables = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_019_add_meta_in_meta_tables"));
const _nc_020_kanban_view = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_020_kanban_view"));
const _nc_021_add_fields_in_token = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_021_add_fields_in_token"));
const _nc_022_qr_code_column_type = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_022_qr_code_column_type"));
const _nc_023_multiple_source = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_023_multiple_source"));
const _nc_024_barcode_column_type = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_024_barcode_column_type"));
const _nc_025_add_row_height = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_025_add_row_height"));
const _nc_026_map_view = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_026_map_view"));
const _nc_027_add_comparison_sub_op = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_027_add_comparison_sub_op"));
const _nc_028_add_enable_scanner_in_form_columns_meta_table = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_028_add_enable_scanner_in_form_columns_meta_table"));
const _nc_029_webhook = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_029_webhook"));
const _nc_030_add_description_field = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_030_add_description_field"));
const _nc_031_remove_fk_and_add_idx = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_031_remove_fk_and_add_idx"));
const _nc_033_add_group_by = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_033_add_group_by"));
const _nc_034_erd_filter_and_notification = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_034_erd_filter_and_notification"));
const _nc_035_add_username_to_users = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_035_add_username_to_users"));
const _nc_036_base_deleted = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_036_base_deleted"));
const _nc_037_rename_project_and_base = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_037_rename_project_and_base"));
const _nc_038_formula_parsed_tree_column = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_038_formula_parsed_tree_column"));
const _nc_039_sqlite_alter_column_types = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_039_sqlite_alter_column_types"));
const _nc_040_form_view_alter_column_types = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_040_form_view_alter_column_types"));
const _nc_041_calendar_view = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_041_calendar_view"));
const _nc_042_user_block = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_042_user_block"));
const _nc_043_user_refresh_token = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_043_user_refresh_token"));
const _nc_044_view_column_index = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_044_view_column_index"));
const _nc_045_extensions = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_045_extensions"));
const _nc_046_comment_mentions = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_046_comment_mentions"));
const _nc_047_comment_migration = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_047_comment_migration"));
const _nc_048_view_links = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_048_view_links"));
const _nc_049_clear_notifications = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_049_clear_notifications"));
const _nc_050_tenant_isolation = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_050_tenant_isolation"));
const _nc_051_source_readonly_columns = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_051_source_readonly_columns"));
const _nc_052_field_aggregation = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_052_field_aggregation"));
const _nc_053_jobs = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_053_jobs"));
const _nc_054_id_length = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_054_id_length"));
const _nc_055_junction_pk = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_055_junction_pk"));
const _nc_056_integration = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_056_integration"));
const _nc_057_file_references = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_057_file_references"));
const _nc_058_button_colum = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_058_button_colum"));
const _nc_059_invited_by = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_059_invited_by"));
const _nc_060_descriptions = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_060_descriptions"));
const _nc_061_integration_is_default = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_061_integration_is_default"));
const _nc_062_integration_store = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_062_integration_store"));
const _nc_063_form_field_filter = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_063_form_field_filter"));
const _nc_064_pg_minimal_dbs = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_064_pg_minimal_dbs"));
const _nc_065_encrypt_flag = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_065_encrypt_flag"));
const _nc_066_ai_button = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_066_ai_button"));
const _nc_067_personal_view = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_067_personal_view"));
const _nc_068_user_delete = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_068_user_delete"));
const _nc_069_ai_prompt = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_069_ai_prompt"));
const _nc_070_data_reflection = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_070_data_reflection"));
const _nc_071_add_meta_in_users = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_071_add_meta_in_users"));
const _nc_072_col_button_pk = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_072_col_button_pk"));
const _nc_073_file_reference_indexes = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_073_file_reference_indexes"));
const _nc_074_missing_context_indexes = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_074_missing_context_indexes"));
const _nc_075_audit_refactor = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_075_audit_refactor"));
const _nc_076_sync_configs = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_076_sync_configs"));
const _nc_077_column_index_name = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_077_column_index_name"));
const _nc_078_mcp_tokens = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_078_mcp_tokens"));
const _nc_079_cross_base_link = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_079_cross_base_link"));
const _nc_080_sync_mappings = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_080_sync_mappings"));
const _nc_081_audit = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_081_audit"));
const _nc_082_row_color_conditions = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_082_row_color_conditions"));
const _nc_083_permissions = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_083_permissions"));
const _nc_084_hook_trigger_fields = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_084_hook_trigger_fields"));
const _nc_085_base_default_role = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_085_base_default_role"));
const _nc_086_dashboards_widgets = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_086_dashboards_widgets"));
const _nc_087_widget_error = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_087_widget_error"));
const _nc_088_add_sso_client_to_api_tokens = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_088_add_sso_client_to_api_tokens"));
const _nc_089_dashboard_sharing = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_089_dashboard_sharing"));
const _nc_090_add_is_new_user_to_users = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_090_add_is_new_user_to_users"));
const _nc_091_unify_model = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_091_unify_model"));
const _nc_092_composite_pk = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_092_composite_pk"));
const _nc_093_oauth_server = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_093_oauth_server"));
const _nc_094_add_meta_to_filter_exp_v2 = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_094_add_meta_to_filter_exp_v2"));
const _nc_096_deprecate_unused = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_096_deprecate_unused"));
const _nc_097_unify_schema = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_097_unify_schema"));
const _nc_098_default_workspace = /*#__PURE__*/ _interop_require_wildcard(require("~/meta/migrations/v2/nc_098_default_workspace"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
let XcMigrationSourcev2 = class XcMigrationSourcev2 {
    // Must return a Promise containing a list of migrations.
    // Migrations can be whatever you want, they will be passed as
    // arguments to getMigrationName and getMigration
    getMigrations() {
        // In this run we are just returning migration names
        return Promise.resolve([
            'nc_011',
            'nc_012_alter_column_data_types',
            'nc_013_sync_source',
            'nc_014_alter_column_data_types',
            'nc_015_add_meta_col_in_column_table',
            'nc_016_alter_hooklog_payload_types',
            'nc_017_add_user_token_version_column',
            'nc_018_add_meta_in_view',
            'nc_019_add_meta_in_meta_tables',
            'nc_020_kanban_view',
            'nc_021_add_fields_in_token',
            'nc_022_qr_code_column_type',
            'nc_023_multiple_source',
            'nc_024_barcode_column_type',
            'nc_025_add_row_height',
            'nc_026_map_view',
            'nc_027_add_comparison_sub_op',
            'nc_028_add_enable_scanner_in_form_columns_meta_table',
            'nc_029_webhook',
            'nc_030_add_description_field',
            'nc_031_remove_fk_and_add_idx',
            'nc_033_add_group_by',
            'nc_034_erd_filter_and_notification',
            'nc_035_add_username_to_users',
            'nc_036_base_deleted',
            'nc_037_rename_project_and_base',
            'nc_038_formula_parsed_tree_column',
            'nc_039_sqlite_alter_column_types',
            'nc_040_form_view_alter_column_types',
            'nc_041_calendar_view',
            'nc_042_user_block',
            'nc_043_user_refresh_token',
            'nc_044_view_column_index',
            'nc_045_extensions',
            'nc_046_comment_mentions',
            'nc_047_comment_migration',
            'nc_048_view_links',
            'nc_049_clear_notifications',
            'nc_050_tenant_isolation',
            'nc_051_source_readonly_columns',
            'nc_052_field_aggregation',
            'nc_053_jobs',
            'nc_054_id_length',
            'nc_055_junction_pk',
            'nc_056_integration',
            'nc_057_file_references',
            'nc_058_button_colum',
            'nc_059_invited_by',
            'nc_060_descriptions',
            'nc_061_integration_is_default',
            'nc_062_integration_store',
            'nc_063_form_field_filter',
            'nc_064_pg_minimal_dbs',
            'nc_065_encrypt_flag',
            'nc_066_ai_button',
            'nc_067_personal_view',
            'nc_068_user_delete',
            'nc_069_ai_prompt',
            'nc_070_data_reflection',
            'nc_071_add_meta_in_users',
            'nc_072_col_button_pk',
            'nc_073_file_reference_indexes',
            'nc_074_missing_context_indexes',
            'nc_075_audit_refactor',
            'nc_076_sync_configs',
            'nc_077_column_index_name',
            'nc_078_mcp_tokens',
            'nc_079_cross_base_link',
            'nc_080_sync_mappings',
            'nc_081_audit',
            'nc_082_row_color_conditions',
            'nc_083_permissions',
            'nc_084_hook_trigger_fields',
            'nc_085_base_default_role',
            'nc_086_dashboards_widgets',
            'nc_087_widget_error',
            'nc_088_add_sso_client_to_api_tokens',
            'nc_089_dashboard_sharing',
            'nc_090_add_is_new_user_to_users',
            'nc_091_unify_model',
            'nc_092_composite_pk',
            'nc_093_oauth_server',
            'nc_094_add_meta_to_filter_exp_v2',
            'nc_096_deprecate_unused',
            'nc_097_unify_schema',
            'nc_098_default_workspace'
        ]);
    }
    getMigrationName(migration) {
        return migration;
    }
    getMigration(migration) {
        switch(migration){
            case 'nc_011':
                return _nc_011;
            case 'nc_012_alter_column_data_types':
                return _nc_012_alter_column_data_types;
            case 'nc_013_sync_source':
                return _nc_013_sync_source;
            case 'nc_014_alter_column_data_types':
                return _nc_014_alter_column_data_types;
            case 'nc_015_add_meta_col_in_column_table':
                return _nc_015_add_meta_col_in_column_table;
            case 'nc_016_alter_hooklog_payload_types':
                return _nc_016_alter_hooklog_payload_types;
            case 'nc_017_add_user_token_version_column':
                return _nc_017_add_user_token_version_column;
            case 'nc_018_add_meta_in_view':
                return _nc_018_add_meta_in_view;
            case 'nc_019_add_meta_in_meta_tables':
                return _nc_019_add_meta_in_meta_tables;
            case 'nc_020_kanban_view':
                return _nc_020_kanban_view;
            case 'nc_021_add_fields_in_token':
                return _nc_021_add_fields_in_token;
            case 'nc_022_qr_code_column_type':
                return _nc_022_qr_code_column_type;
            case 'nc_023_multiple_source':
                return _nc_023_multiple_source;
            case 'nc_024_barcode_column_type':
                return _nc_024_barcode_column_type;
            case 'nc_025_add_row_height':
                return _nc_025_add_row_height;
            case 'nc_026_map_view':
                return _nc_026_map_view;
            case 'nc_027_add_comparison_sub_op':
                return _nc_027_add_comparison_sub_op;
            case 'nc_028_add_enable_scanner_in_form_columns_meta_table':
                return _nc_028_add_enable_scanner_in_form_columns_meta_table;
            case 'nc_029_webhook':
                return _nc_029_webhook;
            case 'nc_030_add_description_field':
                return _nc_030_add_description_field;
            case 'nc_031_remove_fk_and_add_idx':
                return _nc_031_remove_fk_and_add_idx;
            case 'nc_033_add_group_by':
                return _nc_033_add_group_by;
            case 'nc_034_erd_filter_and_notification':
                return _nc_034_erd_filter_and_notification;
            case 'nc_035_add_username_to_users':
                return _nc_035_add_username_to_users;
            case 'nc_036_base_deleted':
                return _nc_036_base_deleted;
            case 'nc_037_rename_project_and_base':
                return _nc_037_rename_project_and_base;
            case 'nc_038_formula_parsed_tree_column':
                return _nc_038_formula_parsed_tree_column;
            case 'nc_039_sqlite_alter_column_types':
                return _nc_039_sqlite_alter_column_types;
            case 'nc_040_form_view_alter_column_types':
                return _nc_040_form_view_alter_column_types;
            case 'nc_041_calendar_view':
                return _nc_041_calendar_view;
            case 'nc_042_user_block':
                return _nc_042_user_block;
            case 'nc_043_user_refresh_token':
                return _nc_043_user_refresh_token;
            case 'nc_044_view_column_index':
                return _nc_044_view_column_index;
            case 'nc_045_extensions':
                return _nc_045_extensions;
            case 'nc_046_comment_mentions':
                return _nc_046_comment_mentions;
            case 'nc_047_comment_migration':
                return _nc_047_comment_migration;
            case 'nc_048_view_links':
                return _nc_048_view_links;
            case 'nc_049_clear_notifications':
                return _nc_049_clear_notifications;
            case 'nc_050_tenant_isolation':
                return _nc_050_tenant_isolation;
            case 'nc_051_source_readonly_columns':
                return _nc_051_source_readonly_columns;
            case 'nc_052_field_aggregation':
                return _nc_052_field_aggregation;
            case 'nc_053_jobs':
                return _nc_053_jobs;
            case 'nc_054_id_length':
                return _nc_054_id_length;
            case 'nc_055_junction_pk':
                return _nc_055_junction_pk;
            case 'nc_056_integration':
                return _nc_056_integration;
            case 'nc_057_file_references':
                return _nc_057_file_references;
            case 'nc_058_button_colum':
                return _nc_058_button_colum;
            case 'nc_059_invited_by':
                return _nc_059_invited_by;
            case 'nc_060_descriptions':
                return _nc_060_descriptions;
            case 'nc_061_integration_is_default':
                return _nc_061_integration_is_default;
            case 'nc_062_integration_store':
                return _nc_062_integration_store;
            case 'nc_063_form_field_filter':
                return _nc_063_form_field_filter;
            case 'nc_064_pg_minimal_dbs':
                return _nc_064_pg_minimal_dbs;
            case 'nc_065_encrypt_flag':
                return _nc_065_encrypt_flag;
            case 'nc_066_ai_button':
                return _nc_066_ai_button;
            case 'nc_067_personal_view':
                return _nc_067_personal_view;
            case 'nc_068_user_delete':
                return _nc_068_user_delete;
            case 'nc_069_ai_prompt':
                return _nc_069_ai_prompt;
            case 'nc_070_data_reflection':
                return _nc_070_data_reflection;
            case 'nc_071_add_meta_in_users':
                return _nc_071_add_meta_in_users;
            case 'nc_072_col_button_pk':
                return _nc_072_col_button_pk;
            case 'nc_073_file_reference_indexes':
                return _nc_073_file_reference_indexes;
            case 'nc_074_missing_context_indexes':
                return _nc_074_missing_context_indexes;
            case 'nc_075_audit_refactor':
                return _nc_075_audit_refactor;
            case 'nc_076_sync_configs':
                return _nc_076_sync_configs;
            case 'nc_077_column_index_name':
                return _nc_077_column_index_name;
            case 'nc_078_mcp_tokens':
                return _nc_078_mcp_tokens;
            case 'nc_079_cross_base_link':
                return _nc_079_cross_base_link;
            case 'nc_080_sync_mappings':
                return _nc_080_sync_mappings;
            case 'nc_081_audit':
                return _nc_081_audit;
            case 'nc_082_row_color_conditions':
                return _nc_082_row_color_conditions;
            case 'nc_083_permissions':
                return _nc_083_permissions;
            case 'nc_084_hook_trigger_fields':
                return _nc_084_hook_trigger_fields;
            case 'nc_085_base_default_role':
                return _nc_085_base_default_role;
            case 'nc_086_dashboards_widgets':
                return _nc_086_dashboards_widgets;
            case 'nc_087_widget_error':
                return _nc_087_widget_error;
            case 'nc_088_add_sso_client_to_api_tokens':
                return _nc_088_add_sso_client_to_api_tokens;
            case 'nc_089_dashboard_sharing':
                return _nc_089_dashboard_sharing;
            case 'nc_090_add_is_new_user_to_users':
                return _nc_090_add_is_new_user_to_users;
            case 'nc_091_unify_model':
                return _nc_091_unify_model;
            case 'nc_092_composite_pk':
                return _nc_092_composite_pk;
            case 'nc_093_oauth_server':
                return _nc_093_oauth_server;
            case 'nc_094_add_meta_to_filter_exp_v2':
                return _nc_094_add_meta_to_filter_exp_v2;
            case 'nc_096_deprecate_unused':
                return _nc_096_deprecate_unused;
            case 'nc_097_unify_schema':
                return _nc_097_unify_schema;
            case 'nc_098_default_workspace':
                return _nc_098_default_workspace;
        }
    }
};
